import {
  Box,
  Button,
  Flex,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import AdminHelpers from "../../../services/admin/admin.service";

export const BulkCourseModal: React.FC<any> = ({
  isOpenBulk,
  onClosed,
  IsBulkCourse = false,
  reload,
  isBatch,
}: {
  IsBulkCourse: boolean;
  isOpenBulk: any;
  onClosed: any;
  reload: any;
  isBatch: boolean;
}) => {
  const toast = useToast();
  const cancelRef = useRef().current;
  const inputRef = useRef<HTMLInputElement | null>(null);

  const [logoFile, setlogoFile] = useState<File | null>(null);
  const [batchFile, setbatchFile] = useState<FormData | null>(null);
  const [filename, setFilename] = useState("");
  const [preview, setPreview] = useState<string | undefined>();

  const [isLoading, setIsLoading] = useState(false);

  // create a preview as a side effect, whenever selected file is changed
  useEffect(() => {
    if (!logoFile) {
      setPreview(undefined);
      return;
    }
    const objectUrl = URL.createObjectURL(logoFile);
    setPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [batchFile]);

  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "30px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  };

  const activeStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };

  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (!acceptedFiles.length) {
      toast({
        title: "File Upload",
        description: "Invalid file uploaded",
        status: "error",
      });
      setbatchFile(null);
    } else {
      const formData = new FormData();
      const file = acceptedFiles[0];

      formData.append("courses", file);
      setbatchFile(formData);

      setFilename(file.name);
      toast({
        title: "File Upload",
        description: "Your file is ready for upload",
        status: "success",
      });
    }
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({ onDrop });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const submitFile = () => {
    setIsLoading(true);
    AdminHelpers.bulkCreateCourse(batchFile)
      .then((res) => {
        setIsLoading(false);
        onClosed();
        reload();
        toast({
          title: "Bulk Course",
          description: "Course created successfully",
          status: "success",
          duration: 2000,
        });
      })
      .catch((err) => {
        setIsLoading(false);
        toast({
          title: "Bulk Course",
          description: `${err.response.data.message}`,
          status: "error",
          duration: 2000,
        });
      });
  };

  const closeModal = () => {
    setIsLoading(false);
    setbatchFile(null);
    setFilename("");
    onClosed();
  };

  return (
    <>
      <Modal
        isOpen={isOpenBulk}
        onClose={closeModal}
        scrollBehavior="inside"
        closeOnOverlayClick={true}
        size="sm"
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={4}>
          <ModalHeader>
            {
              <Text
                fontSize="21px"
                fontWeight="700"
                pb={1}
                textTransform="none"
                pl={3}
                color="#2B2B2B"
              >
                New Course(s)
              </Text>
            }
          </ModalHeader>
          <ModalCloseButton size="sm" />
          <ModalBody pb={6}>
            <Box mt={2}>
              {isBatch ? (
                <Box>
                  <form>
                    <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                      Upload Course Template
                    </FormLabel>
                    <div {...getRootProps({ style })}>
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <p>Drop the files here ...</p>
                      ) : (
                        <p
                          style={{
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            boxSizing: "border-box",
                          }}
                        >
                          {filename !== "" ? (
                            <Text>{filename}</Text>
                          ) : (
                            <span>
                              Drag and drop or browse file <br /> Only
                              Excel(.xls) files allowed{" "}
                            </span>
                          )}
                        </p>
                      )}
                    </div>

                    <Flex mt={12} justifyContent="end">
                      <HStack>
                        <Button
                          size="sm"
                          px={6}
                          fontSize={12}
                          ref={cancelRef}
                          // onClick={() => onClosed()}
                          onClick={() => closeModal()}
                        >
                          Cancel
                        </Button>
                        <Button
                          colorScheme="red"
                          size="sm"
                          px={6}
                          onClick={() => {
                            submitFile();
                          }}
                          fontSize={12}
                          isLoading={isLoading}
                          isDisabled={isLoading}
                        >
                          {" "}
                          Save
                        </Button>
                      </HStack>
                    </Flex>
                  </form>
                </Box>
              ) : (
                ""
              )}
            </Box>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
